// Last modified: 2022/06/20 09:10:24
import SkipToContent from './SkipToContent.vue';
export default SkipToContent;
